import {FormGrid} from '../../../../components/form/form_grid.tsx';
import {__, transString} from '../../../../support/lang/translations.ts';
import {CustomerFieldKeys, getValue} from '../../../../support/get_data.ts';
import {Customer} from '../../../../gql/customer/graphql.ts';

interface OwnProps {
    meData?: Customer | null;
    isLoading: boolean;
}
export function CustomerDataForm({meData, isLoading}: OwnProps) {
    const nameData = getValue(meData, CustomerFieldKeys.NAME);
    const prepositionData = getValue(meData, CustomerFieldKeys.PREPOSITION);
    const surNameData = getValue(meData, CustomerFieldKeys.SURNAME);

    const streetData = getValue(meData, CustomerFieldKeys.STREET);
    const houseNumberData = getValue(meData, CustomerFieldKeys.HOUSE_NUMBER);
    const houseNumberAdditionData = getValue(meData, CustomerFieldKeys.HOUSE_NUMBER_ADDITION);
    const postalCodeData = getValue(meData, CustomerFieldKeys.POSTAL_CODE);
    const cityData = getValue(meData, CustomerFieldKeys.CITY);

    const emailData = getValue(meData, CustomerFieldKeys.EMAIL);
    const phoneNumberData = getValue(meData, CustomerFieldKeys.PHONE_NUMBER);

    return (
        <>
            <FormGrid custom={true}>
                <fieldset>
                    <legend data-grid-column-start={1} data-grid-column-end={13}>
                        {__('profile.fields.full_name')}
                    </legend>
                    <input
                        data-grid-column-start={1}
                        data-grid-column-end={7}
                        defaultValue={nameData?.value ?? ''}
                        placeholder={transString('profile.fields.name')}
                        name={nameData?.key ?? CustomerFieldKeys.NAME}
                        required={true}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={7}
                        data-grid-column-end={9}
                        defaultValue={prepositionData?.value ?? ''}
                        placeholder={transString('profile.fields.preposition')}
                        name={prepositionData?.key ?? CustomerFieldKeys.PREPOSITION}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={9}
                        data-grid-column-end={13}
                        defaultValue={surNameData?.value ?? ''}
                        placeholder={transString('profile.fields.surname')}
                        name={surNameData?.key ?? CustomerFieldKeys.SURNAME}
                        required={true}
                        disabled={isLoading}
                    />
                </fieldset>
            </FormGrid>
            <FormGrid custom={true}>
                <fieldset>
                    <legend data-grid-column-start={1} data-grid-column-end={13}>
                        Adres
                    </legend>
                    <input
                        data-grid-column-start={1}
                        data-grid-column-end={7}
                        defaultValue={streetData?.value ?? ''}
                        placeholder={transString('profile.fields.street')}
                        name={streetData?.key ?? CustomerFieldKeys.STREET}
                        required={true}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={7}
                        data-grid-column-end={9}
                        defaultValue={houseNumberData?.value ?? ''}
                        placeholder={transString('profile.fields.house_number')}
                        name={houseNumberData?.key ?? CustomerFieldKeys.HOUSE_NUMBER}
                        required={true}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={9}
                        data-grid-column-end={13}
                        defaultValue={houseNumberAdditionData?.value ?? ''}
                        placeholder={transString('profile.fields.house_number_addition')}
                        name={houseNumberAdditionData?.key ?? CustomerFieldKeys.HOUSE_NUMBER_ADDITION}
                        disabled={isLoading}
                    />
                </fieldset>
            </FormGrid>
            <FormGrid custom={true}>
                <fieldset>
                    <input
                        data-grid-column-start={1}
                        data-grid-column-end={7}
                        defaultValue={postalCodeData?.value ?? ''}
                        placeholder={transString('profile.fields.postal_code')}
                        name={postalCodeData?.key ?? CustomerFieldKeys.POSTAL_CODE}
                        required={true}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={7}
                        data-grid-column-end={13}
                        defaultValue={cityData?.value ?? ''}
                        placeholder={transString('profile.fields.city')}
                        name={cityData?.key ?? CustomerFieldKeys.CITY}
                        required={true}
                        disabled={isLoading}
                    />
                </fieldset>
            </FormGrid>
            <FormGrid>
                <label>
                    {emailData?.name ?? __('profile.fields.email')}
                    <input
                        defaultValue={emailData?.value ?? ''}
                        name={emailData?.key ?? CustomerFieldKeys.EMAIL}
                        type="email"
                        required={true}
                        disabled={isLoading}
                    />
                </label>
                <label>
                    {phoneNumberData?.name ?? __('profile.fields.phone')}
                    <input
                        defaultValue={phoneNumberData?.value ?? ''}
                        name={phoneNumberData?.key ?? CustomerFieldKeys.PHONE_NUMBER}
                        type="tel"
                        required={true}
                        disabled={isLoading}
                    />
                </label>
            </FormGrid>
        </>
    );
}
